<template>
<vl-sidebar class="kl-sidebar">
    <slot></slot>
</vl-sidebar>
</template>

<script lang="ts">

import {defineComponent} from 'vue';

export default defineComponent({
    compatConfig: {
        MODE: 3,
    },
    name: 'kl-sidebar',
    props: {
    }
})

</script>

<style scoped lang="scss">
:deep() {
    @import "./kl-sidebar.scss";
}
</style>
